import React from 'react'
import { toEmbedUrl } from '../utils/youtube'

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0, 0, 0, 0.85)',
  zIndex: 1000,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const contentStyle = {
  position: 'relative',
  width: '90vw',
  maxWidth: '960px',
  aspectRatio: '16 / 9',
}

const iframeStyle = {
  width: '100%',
  height: '100%',
  border: 'none',
}

export default class YouTubeModal extends React.Component {
  componentDidMount() {
    document.addEventListener('keyup', this.handleEsc)
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleEsc)
  }

  handleEsc = (e) => {
    if (e.keyCode === 27) this.props.onClose()
  }

  handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) this.props.onClose()
  }

  render() {
    const embedUrl = toEmbedUrl(this.props.youtubeUrl)
    if (!embedUrl) return null

    return (
      <div style={overlayStyle} onClick={this.handleOverlayClick}>
        <div style={contentStyle}>
          <iframe
            src={embedUrl}
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="YouTube video"
            style={iframeStyle}
          />
        </div>
      </div>
    )
  }
}
